import { Empty, KpiStrip, BlockHead, ExpandTable, Selo } from "../../components/primitives";
import { STATUS_CFG, AMBIENTE_CFG } from "./FluxoMedClientes";

function fmtData(ts) {
  if (!ts) return "—";
  return new Date(ts).toLocaleDateString("pt-BR", { day: "2-digit", month: "short", year: "numeric" });
}

export function FluxoMedDashboard({ clientes, onOpen }) {
  const total       = clientes.length;
  const producao    = clientes.filter((c) => c.status === "producao").length;
  const homologacao = clientes.filter((c) => c.status === "homologacao").length;
  const rascunho    = clientes.filter((c) => c.status === "rascunho").length;
  const pausado     = clientes.filter((c) => c.status === "pausado").length;

  const kpis = [
    { label: "Clientes",       value: total },
    { label: "Em produção",    value: producao, tone: "ok", sub: total ? `${Math.round((producao / total) * 100)}% do total` : undefined },
    { label: "Em homologação", value: homologacao },
    { label: "Rascunhos",      value: rascunho },
  ];
  if (pausado > 0) kpis.push({ label: "Pausados", value: pausado, sub: "rever", tone: "bad" });

  return (
    <div className="view" style={{ paddingTop: 0 }}>
      <BlockHead title="Visão geral" sub="Clientes FluxoMed. Clique na linha para ver os detalhes técnicos." />

      <KpiStrip style={{ marginBottom: 16 }} items={kpis} />

      {total === 0 ? (
        <Empty icon="⚕" text="Nenhum cliente FluxoMed cadastrado ainda." />
      ) : (
        <ExpandTable
          minWidth={680}
          rows={clientes}
          columns={[
            { key: "nome", label: "Cliente", render: (c) => (
              <div><div className="name">{c.nome}</div>{c.medico_nome && <div className="sub">{c.medico_nome}</div>}</div>
            ) },
            { key: "status", label: "Situação", render: (c) => {
              const sCfg = STATUS_CFG[c.status] || STATUS_CFG.rascunho;
              return <Selo tone={sCfg.tone}>{sCfg.label}</Selo>;
            } },
            { key: "amb", label: "Ambiente", render: (c) => {
              const aCfg = AMBIENTE_CFG[c.ambiente] || AMBIENTE_CFG.lab;
              return <Selo tone={aCfg.tone} dot={false}>{aCfg.label}</Selo>;
            } },
            { key: "upd", label: "Atualizado", align: "right", render: (c) => <span className="sub">{fmtData(c.updated_at)}</span> },
          ]}
          detail={(c) => (
            <div className="detail-grid">
              <dl className="facts">
                {c.medico_especialidade && <><dt>Especialidade</dt><dd>{c.medico_especialidade}</dd></>}
                {c.instancia_evolution && <><dt>Instância</dt><dd>{c.instancia_evolution}</dd></>}
                {c.supabase_project && <><dt>Supabase</dt><dd style={{ fontFamily: "var(--font-data)", fontSize: 12.5 }}>{c.supabase_project}</dd></>}
                {c.origem_template && <><dt>Template</dt><dd>{c.origem_template}</dd></>}
                <dt>Criado em</dt><dd>{fmtData(c.created_at)}</dd>
              </dl>
              <div className="detail-actions">
                <button type="button" className="btn btn-primary btn-sm" onClick={() => onOpen(c.id)}>Abrir ficha</button>
              </div>
            </div>
          )}
        />
      )}
    </div>
  );
}
